import script from "./CustomCheckboxComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomCheckboxComponent.vue?vue&type=script&setup=true&lang=ts"

import "./CustomCheckboxComponent.vue?vue&type=style&index=0&id=6d58cc9a&lang=css"

const __exports__ = script;

export default __exports__